<template>
  <div style="padding: 1rem 1rem; position: relative;">
    <div style="font-weight: 400; color: rgba(0,0,0,0.8); margin-bottom: 20px;" class="d-flex flex-y-center flex-between">
      <div class="d-flex flex-y-center pointer" style="padding: 0.3rem 0.3rem 0 0;" @click="goBack()">
        <img src="@/assets/icon-back.png" width="40" height="40" alt="">
        <span style="margin-left: 10px; color: rgba(0,0,0,0.8); font-weight: 600; font-size: 20px;">签约信息</span>
      </div>
    </div>

    <div class="hidden-xs-only" style="position: absolute;top: 0;right: 0;z-index: 0;">
      <img src="@/assets/submissions-background-cover.png" style="width: 200px;">
    </div>

    <el-form :model="form" :rules="rules" ref="form" label-position="top" label-width="100px" style="padding: 32px; border-radius: 8px;">
      <el-row :gutter="20">
        <el-col :xs="24" :sm="12" :md="6">
          <el-form-item label="真实姓名" prop="name" required>
            <el-input v-model="form.name" placeholder="请输入内容" />
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="6">
          <el-form-item label="笔名" prop="penname" required>
            <el-input v-model="form.penname" placeholder="请输入内容" />
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="6">
          <el-form-item label="身份证号" prop="idNo" required>
            <el-input v-model="form.idNo" placeholder="请输入内容" />
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="6">
          <el-form-item label="手机号" prop="phone" required>
            <el-input v-model="form.phone" placeholder="请输入内容" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="联系地址" prop="contactAddress" required>
        <el-input v-model="form.contactAddress" placeholder="请输入内容" />
      </el-form-item>
      <el-form-item label="户籍地址" prop="permanentAddress" required>
        <el-input v-model="form.permanentAddress" placeholder="请输入内容" />
      </el-form-item>
      <el-form-item label="QQ" prop="qq" required>
        <el-input v-model="form.qq" placeholder="请输入内容" />
      </el-form-item>
      <el-form-item label="身份证" required prop="idcardFront">
        <el-row :gutter="20">
          <el-col :xs="24" :sm="12">
            <PicUploader ref="lyuploader1" :direction="'front'" :limit="1" :url="form.idcardFront" @update="url => form.idcardFront = url" />
          </el-col>
          <el-col :xs="24" :sm="12">
            <PicUploader ref="lyuploader1" :direction="'back'" :limit="1" :url="form.idcardBack" @update="url => form.idcardBack = url" />
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item label="收款方式" prop="signReceiveType" required>
        <el-radio-group v-model="form.signReceiveType">
          <el-radio label="WEIXIN">微信</el-radio>
          <el-radio label="ZHIFUBAO">支付宝</el-radio>
          <el-radio label="BANK_CARD">银行卡</el-radio>
        </el-radio-group>
      </el-form-item>

      <!-- 微信支付信息 -->
      <div v-if="form.signReceiveType === 'WEIXIN'">
        <el-form-item label="微信号" prop="weixinNo" required>
          <el-input v-model="form.weixinNo" placeholder="请输入微信号" />
        </el-form-item>
        <el-form-item label="微信手机号" prop="weixinPhone" required>
          <el-input v-model="form.weixinPhone" placeholder="请输入微信手机号" />
        </el-form-item>
        <el-form-item label="微信真实姓名" prop="weixinRealName" required>
          <el-input v-model="form.weixinRealName" placeholder="请输入微信真实姓名" />
        </el-form-item>
      </div>

      <!-- 支付宝支付信息 -->
      <div v-if="form.signReceiveType === 'ZHIFUBAO'">
        <el-form-item label="支付宝账号" prop="zhifubaoNo" required>
          <el-input v-model="form.zhifubaoNo" placeholder="请输入支付宝账号" />
        </el-form-item>
        <el-form-item label="支付宝姓名" prop="zhifubaoName" required>
          <el-input v-model="form.zhifubaoName" placeholder="请输入支付宝姓名" />
        </el-form-item>
      </div>

      <!-- 银行卡支付信息 -->
      <div v-if="form.signReceiveType === 'BANK_CARD'">
        <el-form-item label="银行名称" prop="bankName" required>
          <el-input v-model="form.bankName" placeholder="请输入银行名称" />
        </el-form-item>
        <el-form-item label="银行卡号" prop="bankNo" required>
          <el-input v-model="form.bankNo" placeholder="请输入银行卡号" />
        </el-form-item>
        <el-form-item label="银行地址" prop="bankAddress" required>
          <el-input v-model="form.bankAddress" placeholder="请输入银行地址" />
        </el-form-item>
        <el-form-item label="绑定用户姓名" prop="bankUserName" required>
          <el-input v-model="form.bankUserName" placeholder="请输入绑定用户姓名" />
        </el-form-item>
        <el-form-item label="绑定用户手机号" prop="bankUserPhone" required>
          <el-input v-model="form.bankUserPhone" placeholder="请输入绑定用户手机号" />
        </el-form-item>
      </div>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">提交审核</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import request from '@/utils/request'
import { mapState, mapMutations } from 'vuex'
import PicUploader from '@/components/PicUploader/idcard'

export default {
  name: 'NotifyList',
  components: {
    PicUploader
  },
  data() {
    // 身份证号验证函数
    const validateIdCard = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入身份证号'))
        return
      }
      // 身份证号格式验证
      const idCardReg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
      if (!idCardReg.test(value)) {
        callback(new Error('身份证号格式不正确'))
        return
      }
      // 年龄验证（必须满18岁）
      if (value.length === 18) {
        const year = parseInt(value.substring(6, 10))
        const month = parseInt(value.substring(10, 12))
        const day = parseInt(value.substring(12, 14))
        const birthDate = new Date(year, month - 1, day)
        const today = new Date()
        let age = today.getFullYear() - birthDate.getFullYear()
        const monthDiff = today.getMonth() - birthDate.getMonth()
        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
          age--
        }
        if (age < 18) {
          callback(new Error('必须满18岁'))
          return
        }
      }
      callback()
    }

    // 手机号验证函数
    const validatePhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入手机号'))
        return
      }
      const phoneReg = /^1[3-9]\d{9}$/
      if (!phoneReg.test(value)) {
        callback(new Error('手机号格式不正确'))
        return
      }
      callback()
    }

    // QQ号验证函数
    const validateQQ = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入QQ号'))
        return
      }
      const qqReg = /^\d{4,20}$/
      if (!qqReg.test(value)) {
        callback(new Error('QQ号格式不正确（4-20位数字）'))
        return
      }
      callback()
    }

    const validateIdCardUpload = (rule, value, callback) => {
      if (!this.form.idcardFront) {
        callback(new Error('请上传身份证正面'))
        return
      }
      if (!this.form.idcardBack) {
        callback(new Error('请上传身份证反面'))
        return
      }
      callback()
    }

    // 银行卡号验证函数
    const validateBankCard = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入银行卡号'))
        return
      }
      const bankCardReg = /^\d{1,19}$/
      if (!bankCardReg.test(value)) {
        callback(new Error('银行卡号格式不正确（最多19位数字）'))
        return
      }
      callback()
    }

    return {
      form: {
        name: '', // 姓名
        penname: '', // 笔名
        idNo: '', // 身份证号
        phone: '', // 手机号
        contactAddress: '', // 联系地址
        permanentAddress: '', // 户籍地址
        qq: '', // QQ
        idcardFront: '', // 身份证正面
        idcardBack: '', // 身份证反面
        enableFlag: true, // 是否启用
        auditState: '-1', // 审核状态: 0-处理中 1-通过 2-不通过, -1-默认
        signReceiveType: 'WEIXIN', // 签约收款方式: WEIXIN ZHIFUBAO BANK_CARD
        auditReason: '', // 审核原因
        accountId: 0, // 用户ID
        // 微信支付信息
        weixinNo: '', // 微信号
        weixinPhone: '', // 微信手机号
        weixinRealName: '', // 微信真实姓名
        // 支付宝支付信息
        zhifubaoNo: '', // 支付宝卡号
        zhifubaoName: '', // 支付宝姓名
        // 银行卡支付信息
        bankName: '', // 银行名称
        bankNo: '', // 银行卡号
        bankAddress: '', // 银行地址
        bankUserName: '', // 绑定用户姓名
        bankUserPhone: '' // 绑定用户手机号
      },
      rules: {
        // 真实姓名：字符串，必填，长度2-12
        name: [
          { required: true, message: '请输入真实姓名', trigger: 'blur' },
          { min: 2, max: 12, message: '真实姓名长度在2到12个字符', trigger: 'blur' }
        ],
        // 笔名：字符串，必填，长度2-12
        penname: [
          { required: true, message: '请输入笔名', trigger: 'blur' },
          { min: 2, max: 12, message: '笔名长度在2到12个字符', trigger: 'blur' }
        ],
        // 身份证号：字符串，必填，长度18，格式校验且必须满18岁
        idNo: [
          { required: true, validator: validateIdCard, trigger: 'blur' }
        ],
        // 手机号：数字，必填，长度11，手机号格式校验
        phone: [
          { required: true, validator: validatePhone, trigger: 'blur' }
        ],
        // 联系地址：字符串，必填，长度<200
        contactAddress: [
          { required: true, message: '请输入联系地址', trigger: 'blur' },
          { max: 200, message: '联系地址长度不能超过200个字符', trigger: 'blur' }
        ],
        // 户籍地址：字符串，必填，长度<200
        permanentAddress: [
          { required: true, message: '请输入户籍地址', trigger: 'blur' },
          { max: 200, message: '户籍地址长度不能超过200个字符', trigger: 'blur' }
        ],
        // QQ：数字，必填，长度4-20
        qq: [
          { required: true, validator: validateQQ, message: '请输入QQ号', trigger: 'blur' }
        ],
        idcardFront: [
          { validator: validateIdCardUpload, trigger: 'blur' }
        ],
        // 收款方式：单选，必填
        signReceiveType: [
          { required: true, message: '请选择收款方式', trigger: 'change' }
        ],
        // 微信号：字符串，必填，长度<50
        weixinNo: [
          { required: true, message: '请输入微信号', trigger: 'blur' },
          { max: 50, message: '微信号长度不能超过50个字符', trigger: 'blur' }
        ],
        // 微信手机号：数字，必填，长度11，手机号格式校验
        weixinPhone: [
          { required: true, validator: validatePhone, trigger: 'blur' }
        ],
        // 微信真实姓名：字符串，必填，长度2-12
        weixinRealName: [
          { required: true, message: '请输入微信真实姓名', trigger: 'blur' },
          { min: 2, max: 12, message: '微信真实姓名长度在2到12个字符', trigger: 'blur' }
        ],
        // 支付宝账号：字符串，必填，长度<50
        zhifubaoNo: [
          { required: true, message: '请输入支付宝账号', trigger: 'blur' },
          { max: 50, message: '支付宝账号长度不能超过50个字符', trigger: 'blur' }
        ],
        // 支付宝姓名：字符串，必填，长度2-12
        zhifubaoName: [
          { required: true, message: '请输入支付宝姓名', trigger: 'blur' },
          { min: 2, max: 12, message: '支付宝姓名长度在2到12个字符', trigger: 'blur' }
        ],
        // 银行名称：字符串，必填
        bankName: [
          { required: true, message: '请输入银行名称', trigger: 'blur' }
        ],
        // 银行卡号：数字，必填，长度<=19
        bankNo: [
          { required: true, validator: validateBankCard, trigger: 'blur' }
        ],
        // 银行地址：字符串，必填，长度<200
        bankAddress: [
          { required: true, message: '请输入银行地址', trigger: 'blur' },
          { max: 200, message: '银行地址长度不能超过200个字符', trigger: 'blur' }
        ],
        // 绑定用户姓名：字符串，必填，长度2-12
        bankUserName: [
          { required: true, message: '请输入绑定用户姓名', trigger: 'blur' },
          { min: 2, max: 12, message: '绑定用户姓名长度在2到12个字符', trigger: 'blur' }
        ],
        // 绑定用户手机号：数字，必填，长度11，手机号格式校验
        bankUserPhone: [
          { required: true, validator: validatePhone, trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    ...mapState(['user', 'token'])
  },
  async mounted() {
    if (this.$route.query.signInfo) {
      const signInfo = JSON.parse(this.$route.query.signInfo)
      console.log({ signInfo })
      this.form = signInfo
    }
  },
  beforeDestroy() {
  },
  methods: {
    ...mapMutations(['setCurrentNotifyId', 'setActiveMenuItem', 'setStory']),
    goBack() {
      this.$router.back()
    },
    async onSubmit() {
      // 表单验证
      this.$refs.form.validate(async(valid) => {
        if (valid) {
          if (this.$route.query.signInfo) {
            await request({
              url: `/auth-service/articles/submit_sign_info/${this.$route.query.id}`,
              method: 'post',
              data: {
                ...this.form
              }
            })
            this.$message.success('提交成功')
            this.$router.back()
            return
          }
          const response = await request({
            url: 'auth-service/signinfos',
            method: 'post',
            data: { ...this.form }
          })
          console.log({ response })
          this.$message.success('提交成功')
          this.$router.back()
          setTimeout(() => {
            this.$eventHub.$emit('sign-continue')
          }, 1000)
        } else {
          this.$message.error('请检查表单填写是否正确')
          return false
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .el-tooltip__popper {
  max-width: 200px;
}
.avatar {
  width: 120px;
  height: 80px;
  display: block;
  border-radius: 6px;
  border: 1px solid #eee;
  object-fit: cover;
}
.avatar-uploader-icon {
  font-size: 32px;
  color: #8c939d;
  width: 120px;
  height: 80px;
  line-height: 80px;
  text-align: center;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  background: #fafbfc;
}
</style>
